import { render } from "./authoring.vue?vue&type=template&id=1b63af0d&ts=true"
import script from "./authoring.vue?vue&type=script&lang=ts"
export * from "./authoring.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__